import { cn } from '@lib/cn'
import { RichTextElement } from '@lib/kontent/models/Elements'
import React, { FC } from 'react'

type RolexRichTextProps = {
  content: RichTextElement
  className?: string
}

export const RolexRichText: FC<RolexRichTextProps> = ({ content, className }) => {
  return (
    <div
      className={cn(
        'text-with-links whitespace-pre-line font-rolex text-[18px] leading-[1.6] text-current lg:text-[19px] huge:text-[20px]',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: content.value }}
    />
  )
}
